import React from 'react';
import { USER_PROFILE } from 'constants/routes';

import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

const PostAnalytics = ({ post, isFullScreen, setShowComments, user }) => {
  const { t } = useTranslation();
  const match = useRouteMatch();

  return (
    <div
      className={`post-info-container ${
        USER_PROFILE === match.path ? 'p-0 my-0' : 'p-3 my-2'
      } d-flex flex-row justify-content-between align-items-center
        ${isFullScreen ? 'full-screen post-info-container-full-screen' : ''}`}
    >
      <div className="post-info-left-container align-items-center font-size-14 d-flex justify-content-between">
        <p className="likes-comments ">
          {post?.likes_count ? post.likes_count : 0} {t(`${post?.likes_count < 2 ? t('like') : t('likes')} `)}
        </p>
        {((post && post.user) || post.user.email === user.email) && (
          <>
            <p className="post-dot" />
            <p className="post-comments mr-4 cursor-pointer" onClick={post.user.following ? setShowComments : undefined}>
              <span>{post?.comments_count ? post.comments_count : 0}</span>
              {t(`${post?.comments_count < 2 ? t('comment') : t('comments')} `)}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PostAnalytics;
